// The owner connects their Google account for Meet links from "Моят профил" → "Интеграции". Google
// sends them back (through the OAuth bridge page) to
//   /my-profile?tab=integrations&googleMeetConnect=1&code=…&state=…&oauth_return=true
// The code on that URL belongs to the Google Meet card, not to a Google login — the marker below
// is how the global login hook (useGoogleAuthReturn) knows to leave it alone.
export const GOOGLE_MEET_CONNECT_PARAM = "googleMeetConnect";

export const isGoogleMeetConnectReturn = (search: string): boolean =>
  new URLSearchParams(search).get(GOOGLE_MEET_CONNECT_PARAM) === "1";
